<template>
  <div class="smartScreen">
    <div class="the-banner"></div>
    <div class="bgbox-white">
     
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "smartScreen"
    };
  }
};
</script>
<style lang="scss" scoped>
// .bgbox-white{
//   height: 400px;
//   background-image: url("../../../assets/images/screen-banner1.jpg");
//   background-repeat: no-repeat;
//   background-position: center;
// }
.the-banner {
  height:10667px;
  background-image: url("../../../assets/images/smarttv-1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}
.module-conts{
  width: 100%;
  overflow: hidden;
  padding: 30px 0;
  box-sizing: border-box;
  max-width: 1200px;
  margin: 0 auto;
  .module-title{
    text-align: center;
    padding-bottom: 40px;
    position: relative;
    &::before{
      content: '';
      width: 70px;
      height: 2px;
      background: #000;
      position: absolute;
      bottom: 30px;
      left: 50%;
      margin-left: -35px;
    }
    .title-cn{
      display: block;
      font-size: 30px;
      color: #0066cc;
    }
    .title-en{
      display: block;
      font-size: 12px;
      color: #757575;
      line-height: 20px;
    }
  }
}

.module1-view{
  width: 100%;
  overflow: hidden;
  .item{
    width: 100%;
    overflow: hidden;
    margin-bottom: 20px;
    &.bg-blue{
      background: #3067ba;
    }
    &.bg-yellow{
      background: #a07244;
    }
    .img-box{
      img{
        display: block;
        margin: 0 auto;
        width: 100%;
        max-width: 500px;
      }
    }
    .infos-box{
      padding: 20px;
      box-sizing: border-box;
      max-width: 500px;
      margin: 0 auto;
      h3{
        font-size: 22px;
        color: #fff;
        font-weight: 400;
        margin-bottom: 10px;
      }
      h4{
        font-size: 12px;
        color: #fff;
        font-weight: 400;
        padding-bottom: 10px;
        border-bottom: 2px solid #fff;
        margin-bottom: 20px;
      }
      p{
        font-size: 14px;
        color: #fff;
        line-height: 26px;
      }
    }
  }
}

.module2-view{
  width: 100%;
  overflow: hidden;
  .img1{
    display: block;
    width: 100%;
    max-width: 435px;
    margin: 0 auto;
  }
  .img2{
    display: block;
    width: 100%;
    max-width: 183px;
    margin: 0 auto;
  }
}

.module3-view{
  img{
    display: block;
    width: 100%;
    max-width: 1082px;
    margin: 0 auto;
  }
}

// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../../assets/images/smarttv-1.jpg");
  }
}
</style>